import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-details} KatHeroDetails Component used display hero details.
 */
@register(KatHero.slotMapping.details.name)
export class KatHeroDetails extends KatLitFilteredElement {
  constructor() {
    super(
      KatHero.slotMapping.details.name,
      KatHero.slotMapping.details.allowed
    );
  }
}
